import React from 'react';
import { colors, typography, layout } from '../articleMinimalStyles';

const ArticleBody = ({ content }) => {
  // Define styles for elements likely within the HTML content
  // Note: These won't apply automatically with dangerouslySetInnerHTML.
  // This requires either rendering structured data OR using CSS for child elements.
  // For this example, we'll wrap in a div and assume global styles might apply,
  // or use a library like styled-components with global styles.
  // A simple approach is to add a className and define styles in a CSS file.
  // But sticking to pure inline styles for the container:
  const styles = {
    bodyContainer: {
      maxWidth: layout.contentMaxWidth, // Limit width for readability
      margin: '0 auto', // Center the text column if page is wider
      fontSize: typography.baseSize,
      lineHeight: 1.7,
      color: colors.primaryText,
    },
    // Styles below are for documentation / CSS approach:
    /*
    paragraph: { marginBottom: '1.2em' },
    heading2: { fontSize: typography.h2Size, fontWeight: typography.boldWeight, marginBottom: '1em', marginTop: '1.8em', lineHeight: 1.3 },
    heading3: { fontSize: typography.h3Size, fontWeight: typography.boldWeight, marginBottom: '0.8em', marginTop: '1.5em', lineHeight: 1.4 },
    listItem: { marginBottom: '0.5em' },
    list: { paddingLeft: '25px', marginBottom: '1.2em' },
    blockQuote: { borderLeft: `3px solid ${colors.accent}`, paddingLeft: '15px', margin: '1.5em 0', fontStyle: 'italic', color: colors.secondaryText },
    imageInContent: { maxWidth: '100%', height: 'auto', margin: '1.5em 0', borderRadius: '4px' },
    codeInline: { backgroundColor: colors.backgroundLight, padding: '2px 5px', borderRadius: '3px', fontFamily: 'monospace', fontSize: '0.9em' },
    */
  };

  // Option 1: dangerouslySetInnerHTML (Use with trusted HTML sources only!)
  return (
    <div
      style={styles.bodyContainer}
      // Add a className here if you prefer to style children via CSS
      // className="article-content"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );

  // Option 2: If content is structured data (e.g., array of objects { type: 'paragraph', text: '...' })
  // return (
  //   <div style={styles.bodyContainer}>
  //     {content.map((block, index) => {
  //       if (block.type === 'paragraph') return <p key={index} style={styles.paragraph}>{block.text}</p>;
  //       if (block.type === 'h2') return <h2 key={index} id={block.id} style={styles.heading2}>{block.text}</h2>;
  //       // ... handle other block types
  //       return null;
  //     })}
  //   </div>
  // );
};

export default ArticleBody;